import React from 'react'

export interface IFlowRouterContext {
  onNextStep: () => void
  onSkipOneStep: () => void
  onPreviousStep: () => void
  onSkipOneStepBack: () => void
  onPostPaymentContinue: () => void
  onPageLoad: () => void
}

const defaultState: IFlowRouterContext = {
  onNextStep: () => undefined,
  onSkipOneStep: () => undefined,
  onPreviousStep: () => undefined,
  onSkipOneStepBack: () => undefined,
  onPostPaymentContinue: () => undefined,
  onPageLoad: () => undefined,
}

export const FlowRouterContext =
  React.createContext<IFlowRouterContext>(defaultState)
